<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              class="min-button ml-2 no-mb"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb ml-2"
              v-if="mode === 'view'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button no-mb ml-2"
              @click="saveUser()"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row justify-content-center">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="d-inline-block mt-2 mb-2">
                    <div
                      class="badge-profile status-confirmed"
                      v-if="user.profile.status === true"
                    >
                      <i
                        class="flaticon-bold-check-3 text-success f25 mr-2"
                      ></i>
                      <span>Active</span>
                    </div>

                    <div class="badge-profile status-cancelled " v-else>
                      <i class="flaticon-bold-cancel text-danger f25 mr-2"></i>
                      <span>Inactive</span>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                      v-if="mode === 'edit'"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="user.profile.image"
                          v-bind:style="{
                            backgroundImage: 'url(' + user.profile.image + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3" v-if="mode === 'edit'">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="selfile"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>

                    <div class="box-profile-one">
                      <h2 class="subtitle mb-1">
                        {{ user.personal_info.first_name }}
                        {{ user.personal_info.last_name }}
                      </h2>

                      <div class="role mb-0">
                        {{ formatPosition(user.agreement.position) }}
                      </div>
                    </div>

                    <div class="badge-status status-new mb-2">
                      {{ formatRole(user.relationship.type) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card ">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="data-block" v-if="mode === 'view'">
                      <span class="content-block" v-if="user.agreement.notes">{{
                        user.agreement.notes
                      }}</span>
                      <span class="content-block" v-else>No notes here</span>
                    </div>

                    <div class="mb-4 " v-if="mode === 'edit'">
                      <el-input
                        v-model="$v.user.agreement.notes.$model"
                        placeholder="Notes"
                        id="customer_notes"
                        name="customer_notes"
                        tabindex="23"
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-12 col-md-12">
          <div class="card">
            <h2 class="subtitle">Personal Info</h2>

            <div v-if="mode === 'view'">
              <div class="row">
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="data-block">
                    <span class="title-block">Full Name</span>
                    <span class="content-block capitalize "
                      >{{ user.personal_info.first_name }}
                      {{ user.personal_info.last_name }}</span
                    >
                  </div>
                </div>
                <div
                  class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.personal_info.gender"
                >
                  <div class="data-block">
                    <span class="title-block">Gender</span>
                    <span class="content-block">{{
                      getGender(user.personal_info.gender)
                    }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.personal_info.date_of_birth"
                >
                  <div class="data-block">
                    <span class="title-block">Date of Birth</span>
                    <span class="content-block">{{
                      user.personal_info.date_of_birth
                    }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.personal_info.document.value"
                >
                  <div class="data-block">
                    <span class="title-block">Document Identity</span>
                    <span class="content-block"
                      ><strong
                        >{{
                          user.personal_info.document.type === "passport"
                            ? "Passport"
                            : "DNI"
                        }}: </strong
                      >{{ user.personal_info.document.value }}</span
                    >
                  </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="data-block">
                    <span class="title-block">Contact Number</span>
                    <span class="content-block">
                      <a :href="`tel:${user.personal_info.phone}`">{{
                        user.personal_info.phone
                      }}</a>
                      <el-tooltip content="Copy" placement="bottom">
                        <span
                          class="curp ml-2"
                          v-clipboard:copy="user.personal_info.phone"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onErrorCopy"
                        >
                          <i class="flaticon-copy link ml-0"></i></span
                      ></el-tooltip>
                    </span>
                  </div>
                </div>
                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.personal_info.contact.value"
                >
                  <div class="data-block">
                    <span class="title-block">Other Contact Info</span>
                    <span class="content-block">
                      <i
                        class="flaticon-bold-whatsapp f16 mr-1"
                        v-if="user.personal_info.contact.type === 'whatsapp'"
                      ></i>
                      <i
                        class="flaticon-bold-logotipo-de-skype f16 mr-1"
                        v-if="user.personal_info.contact.type === 'skype'"
                      ></i>

                      {{ user.personal_info.contact.value }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-if="mode === 'edit'">
              <div class="row mt-2">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <base-input
                    id="first_name"
                    name="first_name"
                    v-model.trim="$v.user.personal_info.first_name.$model"
                    label="First Name"
                    placeholder="First Name"
                    format="capitalize"
                    maxlength="45"
                    markrequired
                    :error="
                      !$v.user.personal_info.first_name.minLength ||
                      $v.user.personal_info.first_name.$error
                        ? `Minimum ${$v.user.personal_info.first_name.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <base-input
                    id="last_name"
                    name="last_name"
                    v-model.trim="$v.user.personal_info.last_name.$model"
                    label="Last Name"
                    placeholder="Last Name"
                    format="capitalize"
                    maxlength="45"
                    markrequired
                    :error="
                      !$v.user.personal_info.last_name.minLength ||
                      $v.user.personal_info.last_name.$error
                        ? `Minimum ${$v.user.personal_info.last_name.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div
                  class="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-12 mb-md-0 mb-4"
                  v-bind:class="{
                    'is-invalid': $v.user.personal_info.gender.$error
                  }"
                >
                  <label class="title-label"
                    ><span class="markrequired">*</span>Gender</label
                  >
                  <div class="">
                    <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                      <b-form-radio-group
                        id="radio-group-2"
                        v-model="$v.user.personal_info.gender.$model"
                        :aria-describedby="ariaDescribedby"
                        name="radio-sub-component"
                        buttons
                        button-variant="outline-neutral"
                        size="md"
                        v-bind:class="{
                          'is-invalid': $v.user.personal_info.gender.$error
                        }"
                      >
                        <b-form-radio value="male">M</b-form-radio>
                        <b-form-radio value="female">F</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                  <small
                    class="invalid-feedback mt-1"
                    v-if="$v.user.personal_info.gender.$error"
                    >Select Gender</small
                  >
                </div>

                <div class="col-xl-3 col-lg-5 col-md-3 col-sm-4 col-12">
                  <base-input
                    label="Date of Birth"
                    v-bind:class="{
                      'is-invalid': $v.user.personal_info.date_of_birth.$error
                    }"
                    :error="
                      $v.user.personal_info.date_of_birth.$error
                        ? `You must be at least 18 years old`
                        : ''
                    "
                    markrequired
                  >
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{
                        altFormat: 'd-M-Y',
                        altInput: true,
                        dateFormat: 'Y-m-d',
                        allowInput: true
                      }"
                      class="input-custom"
                      v-model="$v.user.personal_info.date_of_birth.$model"
                      id="date"
                      name="user_birth"
                      placeholder="-"
                    ></flat-picker>
                  </base-input>
                </div>

                <div class="col-xl-4 col-lg-7 col-md-6 col-sm-6 col-12">
                  <label class="title-label">Document Identity</label>
                  <div class="d-flex">
                    <b-form-group
                      v-slot="{ ariaDescribedby2 }"
                      class="d-inline-flex"
                    >
                      <b-form-radio-group
                        v-model="$v.user.personal_info.document.type.$model"
                        :aria-describedby="ariaDescribedby2"
                        id="radio-platform"
                        name="radio-platform"
                        tabindex="7"
                        buttons
                        button-variant="outline-neutral"
                        size="md"
                      >
                        <b-form-radio
                          value="passport"
                          class="pc-0"
                          title="Passport"
                          tabindex="7"
                          >PASS</b-form-radio
                        >
                        <b-form-radio value="dni" class="pc-0" title="DNI"
                          >DNI</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-form-group>

                    <base-input
                      v-model.trim="$v.user.personal_info.document.value.$model"
                      placeholder="Other Contact Info"
                      id="user_type_doc_identity"
                      name="user_type_doc_identity"
                      tabindex="8"
                      class="d-inline-flex"
                    >
                    </base-input>
                  </div>

                  <small
                    class="invalid-feedback w-100"
                    v-if="$v.user.personal_info.document.value.$error"
                    >{{
                      !$v.user.personal_info.document.value.minLength ||
                      $v.user.personal_info.document.value.$error
                        ? `Minimum ${$v.user.personal_info.document.value.$params.minLength.min} letters.`
                        : ""
                    }}</small
                  >
                </div>

                <div
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 inputphone mb-md-0 mb-4"
                  v-bind:class="{
                    'is-invalid': $v.user.personal_info.phone.$error
                  }"
                >
                  <label class="title-label"
                    ><span class="markrequired">*</span>Contact Number</label
                  >
                  <vue-tel-input
                    v-model="phoneFormat"
                    key="NumberPhoneuser"
                    inputId="NumberPhoneuser"
                    name="NumberPhoneuser"
                    required
                    mode="international"
                    inputClasses="input no-label no-err"
                    :dynamicPlaceholder="true"
                    :disabledFetchingCountry="true"
                    :validCharactersOnly="true"
                    :wrapperClasses="[
                      $v.user.personal_info.phone.$error ? 'is-invalid' : '',
                      'mb-0'
                    ]"
                    @input="phoneInput"
                  ></vue-tel-input>
                  <small
                    class="invalid-feedback mt-1"
                    v-if="$v.user.personal_info.phone.$error"
                    >Enter a valid phone</small
                  >
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <label class="title-label">Other Contact Info</label>
                  <div class="d-flex">
                    <b-form-group
                      v-slot="{ ariaDescribedby2 }"
                      class="d-inline-flex"
                    >
                      <b-form-radio-group
                        v-model="$v.user.personal_info.contact.type.$model"
                        :aria-describedby="ariaDescribedby2"
                        id="radio-platform"
                        name="radio-platform"
                        tabindex="7"
                        buttons
                        button-variant="outline-neutral"
                        size="md"
                      >
                        <b-form-radio
                          value="whatsapp"
                          class="pc-2"
                          title="Whatsapp"
                          tabindex="7"
                          ><i class="flaticon-bold-whatsapp f16"></i
                        ></b-form-radio>
                        <b-form-radio value="skype" class="pc-2" title="Skype"
                          ><i class="flaticon-bold-logotipo-de-skype f16"></i
                        ></b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                    <base-input
                      v-model.trim="user.personal_info.contact.value"
                      placeholder="Other Contact Info"
                      id="user_phone_optional"
                      name="user_phone_optional"
                      tabindex="8"
                      class="d-inline-flex"
                    >
                    </base-input>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">Working Info</h2>
            <div v-if="mode === 'view'">
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                  <div class="data-block">
                    <span class="title-block">Position</span>
                    <span class="content-block">
                      {{ formatPosition(user.agreement.position) }}</span
                    >
                  </div>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 ">
                  <div class="data-block">
                    <span class="title-block">Start Date</span>
                    <span class="content-block">{{
                      user.agreement.start_date
                    }}</span>
                  </div>
                </div>
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 "
                  v-if="user.agreement.end_date"
                >
                  <div class="data-block">
                    <span class="title-block">End Date</span>
                    <span class="content-block">{{
                      user.agreement.end_date
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="mode === 'edit'">
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                  <WSelect
                    v-bind:class="{
                      'is-invalid': $v.user.agreement.position.$error
                    }"
                    placeholder="Position"
                    v-model="$v.user.agreement.position.$model"
                    id="user_position"
                    name="user_position"
                    label="Position"
                    filterable
                    markrequired
                    :error="
                      $v.user.agreement.position.$error ? `Select Position` : ''
                    "
                  >
                    <el-option
                      v-for="option in positionOptions"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </WSelect>
                </div>

                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 flatpickr-append"
                >
                  <base-input
                    label="Start Date"
                    v-bind:class="{
                      'is-invalid': $v.user.agreement.start_date.$error
                    }"
                    :error="
                      $v.user.agreement.start_date.$error
                        ? `Enter Start Date`
                        : ''
                    "
                    markrequired
                  >
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{
                        altFormat: 'd-M-Y',
                        altInput: true,
                        dateFormat: 'Y-m-d',
                        allowInput: true,
                        wrap: true
                      }"
                      class="input-custom"
                      v-model="$v.user.agreement.start_date.$model"
                      id="date"
                      name="start_date"
                      placeholder=""
                    ></flat-picker>
                    <template slot="append">
                      <button class="b-icon" type="button" data-clear>
                        <i class="flaticon-remove" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </button>
                    </template>
                  </base-input>
                </div>
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 flatpickr-append"
                >
                  <base-input label="End Date">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{
                        altFormat: 'd-M-Y',
                        altInput: true,
                        dateFormat: 'Y-m-d',
                        allowInput: true,
                        wrap: true
                      }"
                      class="input-custom"
                      v-model="$v.user.agreement.end_date.$model"
                      id="end_date"
                      name="end_date"
                      placeholder=""
                    ></flat-picker>
                    <template slot="append">
                      <button class="b-icon" type="button" data-clear>
                        <i class="flaticon-remove" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </button>
                    </template>
                  </base-input>
                </div>

                <div
                  class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 switch-md mb-2"
                >
                  <label class="title-label"
                    ><span class="markrequired">*</span>Active</label
                  >
                  <base-switch
                    class="sw-md mt-2 ml-3"
                    v-model="user.profile.status"
                  ></base-switch>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">Account Info</h2>

            <div v-if="mode === 'view'">
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-2">
                  <div class="data-block">
                    <span class="title-block">Role</span>
                    <span class="content-block">
                      {{ formatRole(user.relationship.type) }}</span
                    >
                  </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                  <div class="data-block">
                    <span class="title-block">Email Address</span>
                    <span class="content-block"> {{ user.account.email }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="mode === 'edit'">
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-2">
                  <WSelect
                    v-bind:class="{
                      'is-invalid': $v.user.relationship.type.$error
                    }"
                    placeholder="Role"
                    v-model="$v.user.relationship.type.$model"
                    id="user_role"
                    name="user_role"
                    label="Role"
                    filterable
                    markrequired
                    :error="
                      $v.user.relationship.type.$error ? `Select Role` : ''
                    "
                  >
                    <el-option
                      v-for="option in rolesOptions"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </WSelect>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                  <base-input
                    id="user_email"
                    name="user_email"
                    v-model.trim="$v.user.account.email.$model"
                    label="Email Address"
                    placeholder="Email Address"
                    v-bind:class="{
                      'is-invalid': $v.user.account.email.$error
                    }"
                    :error="emailValidationMessage($v.user.account.email)"
                    autocomplete="off"
                    markrequired
                  />
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 d-md-block d-none"></div>
                <div
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                  v-bind:class="{
                    'is-invalid': $v.user.account.password.$error,
                    valid: $v.user.account.password.strongPassword
                  }"
                >
                  <base-input
                    class="input-append mb-0"
                    placeholder="Password"
                    v-bind:class="{
                      'is-invalid': $v.user.account.password.$error
                    }"
                    v-model="$v.user.account.password.$model"
                    :type="typepassword"
                    name="password"
                    id="password"
                    autocomplete="new-password"
                    label="Password"
                    :tooltip="true"
                    titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                    contentTooltip='<ul class="ul-pop">
                                  <li>Minimum 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                    ><template slot="append">
                      <span @click="seePassword()" class="icon-button"
                        ><i
                          v-bind:class="{
                            'flaticon-view-1': typepassword == 'password',
                            'flaticon-hidden': typepassword == 'text'
                          }"
                        ></i
                      ></span>
                    </template>
                  </base-input>
                  <small
                    class="invalid-feedback mt--1"
                    v-if="$v.user.account.password.$error"
                  >
                    {{ passwordValidationMessage($v.user.account.password) }}
                  </small>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                  <base-input
                    v-model.trim="$v.repeatPassword.$model"
                    label="Confirm Password"
                    placeholder="Confirm Password "
                    type="password"
                    id="confirm_password"
                    name="confirm_password"
                    :error="
                      !$v.repeatPassword.sameAsPassword ||
                      $v.repeatPassword.$error
                        ? `Passwords must be identical.`
                        : ''
                    "
                  />
                </div>
                <div
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12  form-group alinmov1"
                >
                  <base-button
                    type="outline-secondary"
                    class="min-button"
                    @click="autogeneratePass()"
                  >
                    <i class="flaticon-bold-lock"></i>Generate Password
                  </base-button>

                  <base-button
                    type="outline-secondary"
                    class="min-button"
                    v-clipboard:copy="user.account.password"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onErrorCopy"
                    v-if="user.account.password"
                  >
                    <i class="flaticon-copy"></i>Copy Password
                  </base-button>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">Address</h2>

            <div v-if="mode === 'view'">
              <div
                class="row"
                v-if="
                  user.address.street ||
                    user.address.city ||
                    user.address.state ||
                    user.address.zip_code ||
                    user.address.country
                "
              >
                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.address.street"
                >
                  <div class="data-block">
                    <span class="title-block"
                      >Street address, apartment, suite, etc.:</span
                    >
                    <span class="content-block">{{ user.address.street }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.address.city"
                >
                  <div class="data-block">
                    <span class="title-block">City</span>
                    <span class="content-block capitalize">{{
                      user.address.city
                    }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.address.state"
                >
                  <div class="data-block">
                    <span class="title-block">State/Province/Region</span>
                    <span class="content-block">{{ user.address.state }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.address.postal_code"
                >
                  <div class="data-block">
                    <span class="title-block">Zip/Postal Code</span>
                    <span class="content-block">{{
                      user.address.postal_code
                    }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="user.address.country"
                >
                  <div class="data-block">
                    <span class="title-block">Country</span>
                    <span class="content-block">{{
                      user.address.country
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="row" v-else>
                <div class="col-12">
                  <div class="data-block">
                    <span class="content-block">No Provided</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="mode === 'edit'">
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <base-input
                    id="user_street"
                    name="user_street"
                    label="Street address, apartment, suite, etc."
                    placeholder="Street"
                    v-model="$v.user.address.street.$model"
                    :error="
                      !$v.user.address.street.minLength ||
                      $v.user.address.street.$error
                        ? `Minimum ${$v.user.address.street.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <base-input
                    id="user_city"
                    name="user_city"
                    label="City"
                    placeholder="City"
                    v-model="$v.user.address.city.$model"
                    :error="
                      !$v.user.address.city.minLength ||
                      $v.user.address.city.$error
                        ? `Minimum ${$v.user.address.city.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <base-input
                    id="user_state"
                    name="user_state"
                    label="State/Province/Region"
                    placeholder="State"
                    v-model="$v.user.address.state.$model"
                    :error="
                      !$v.user.address.state.minLength ||
                      $v.user.address.state.$error
                        ? `Minimum ${$v.user.address.state.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <base-input
                    id="user_zipcode"
                    name="user_zipcode"
                    label="Zip Code"
                    placeholder="Zip Code"
                    v-model.trim="$v.user.address.postal_code.$model"
                    type="text"
                    :error="
                      !$v.user.address.postal_code.minLength ||
                      $v.user.address.postal_code.$error
                        ? `Minimum ${$v.user.address.postal_code.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <WSelect
                    v-bind:class="{
                      'is-invalid': $v.user.address.country.$error
                    }"
                    id="user_country"
                    name="user_country"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="remoteMethod"
                    :loading="loading"
                    placeholder="Enter a Country"
                    v-model="$v.user.address.country.$model"
                    label="Country"
                    markrequired
                    :error="
                      $v.user.address.country.$error ? `Enter a Country` : ''
                    "
                  >
                    <el-option
                      v-for="country in options"
                      :value="country.name"
                      :label="country.name"
                      :key="country.name"
                    ></el-option>
                  </WSelect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { UsersAPI } from "../../../core/api";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import { cloneDeep, isEqual } from "lodash";
import moment from "moment-timezone";
import generator from "generate-password";
import { goBack, validateEmail } from "../../../helpers/commons.helpers";
import { formatPosition, formatRole } from "../utils/formatUserType";
import { FileService } from "../../../core/services";
import { POSITION_OPTIONS, ROLES_OPTIONS } from "../constants/team.constants";
import {
  emailValidationMessage,
  passwordValidationMessage,
  validateBirth
} from "../services/validation.services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditMember",
  data() {
    return {
      user: {
        personal_info: {
          first_name: "",
          last_name: "",
          phone: "",
          gender: "",
          date_of_birth: "",
          document: {
            type: "",
            value: ""
          },
          contact: {
            type: "whatsapp",
            value: ""
          }
        },
        account: {
          email: "",
          password: ""
        },
        profile: {
          image: "",
          status: true
        },
        relationship: {
          owner: "",
          type: "user"
        },
        address: {
          country: "",
          state: "",
          city: "",
          street: "",
          postal_code: ""
        },
        agreement: {
          start_date: "",
          end_date: "",
          position: "accounting",
          notes: ""
        }
      },
      loading: false,
      options: [],
      phoneFormat: "",
      repeatPassword: "",
      userCopy: {},
      onSaved: false,
      positionOptions: cloneDeep(POSITION_OPTIONS),
      rolesOptions: cloneDeep(ROLES_OPTIONS),
      typepassword: "password",
      imagePreview: "",
      selfile: false,
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      userId: null,
      lastEmail: "",
      mode: "view"
    };
  },
  async created() {
    this.setItemsBread([
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Team",
        to: "/team"
      },

      {
        text: "Member Profile",
        active: true
      }
    ]);
    if (this.sesion.role !== "super_admin") {
      this.rolesOptions = this.rolesOptions.filter(role => {
        return ["manager", "support", "user"].includes(role.value);
      });
    }
    this.userId = this.$route.params.id;
    await this.getMember(this.userId);
  },

  methods: {
    formatPosition,
    formatRole,
    passwordValidationMessage,
    emailValidationMessage,
    async getMember(userId) {
      try {
        let { data } = await UsersAPI.getOneUser(userId, this.sesion.token);
        if (data.status) {
          let user = data.data;
          this.user.personal_info.first_name = user.personal_info.first_name;
          this.user.personal_info.last_name = user.personal_info.last_name;
          this.user.personal_info.phone = user.personal_info.phone;
          this.user.personal_info.gender = user.personal_info.gender;
          this.user.personal_info.date_of_birth = moment(
            user.personal_info.date_of_birth
          )
            .utc(false)
            .format("YYYY-MM-DD");
          this.user.personal_info.document = cloneDeep(
            user.personal_info.document
          );
          this.user.personal_info.contact = cloneDeep(
            user.personal_info.contact
          );
          this.phoneFormat = this.user.personal_info.phone;
          this.options = [{ name: user.address.country }];
          this.user.address.country = user.address.country;
          this.user.address.state = user.address.state;
          this.user.address.city = user.address.city;
          this.user.address.street = user.address.street;
          this.user.address.postal_code = user.address.postal_code;
          this.user.agreement.start_date = moment(user.agreement.start_date)
            .utc(false)
            .format("YYYY-MM-DD");

          this.user.agreement.end_date = user.agreement.end_date
            ? moment(user.agreement.end_date)
                .utc(false)
                .format("YYYY-MM-DD")
            : "";

          this.user.agreement.position = user.agreement.position;
          this.user.agreement.notes = user.agreement.notes;
          this.user.profile.image = user.profile.image;
          this.user.profile.status = user.profile.status;
          this.user.account.email = user.account.email;
          this.$v.user.account.email.$model = user.account.email;
          this.lastEmail = user.account.email;
          this.user.relationship.owner = user.relationship.owner;
          this.user.relationship.type = user.relationship.type;
          this.userCopy = cloneDeep(this.user);
        } else {
          this.$notify({
            type: "warning",
            title: "Not Found!",
            message: "This user does not exist, please select another user",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error getting the member, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    phoneInput(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.user.personal_info.phone = result.number.e164;
      } else {
        this.user.personal_info.phone = "";
      }
    },
    remoteMethod(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.options = [];
      }
    },
    async updateUser(userId, user, message, route = null) {
      try {
        this.setLoad(true);
        let { data } = await UsersAPI.updateUser(
          userId,
          user,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSaved = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: message,
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/team");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the member, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the member, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async saveUser(route = null) {
      if (!this.$v.user.$invalid) {
        var user = cloneDeep(this.user);
        user.relationship.owner = this.getOwner();
        user.personal_info.full_name = `${user.personal_info.first_name} ${user.personal_info.last_name}`;
        this.updateUser(this.userId, user, "The member has been Saved", route);
      } else {
        this.$v.user.$touch();
        this.$v.repeatPassword.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getOwner() {
      return this.sesion.role === this.sesion.account_type.type
        ? this.sesion.id
        : this.sesion.account_type.owner;
    },
    autogeneratePass() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.user.account.password = password;
      this.repeatPassword = password;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The password has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The password could not be copied",
        icon: "flaticon-remove"
      });
    },
    seePassword() {
      this.typepassword = this.typepassword == "password" ? "text" : "password";
    },
    readFile: async function(event) {
      const [file] = event.target.files;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let fileData = FileService.generateResourceData(
          "/users/avatars",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.imagePreview = URL.createObjectURL(file);
          this.user.profile.image = urlFile;
          this.selfile = true;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile: function() {
      this.imagePreview;
      this.user.profile.image = "";
      this.selfile = false;
    },
    isInMemberModule(modules = []) {
      if (!(modules.indexOf("users") > -1)) {
        this.setUserSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(to, from, next) {
      let isChanged = !isEqual(this.user, this.userCopy);
      if (isChanged && !this.onSaved) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The member has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "Cancel",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveUser(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    getGender(gender) {
      if (gender === "male") {
        return "Male";
      } else if (gender == "female") {
        return "Female";
      } else {
        return "Other";
      }
    },
    async verifyUserEmail(email) {
      try {
        let { data } = await UsersAPI.verifyUserExist(
          email.toLowerCase(),
          this.sesion.token
        );
        if (data.status) {
          let verifyUserExist = data.data.exist;
          return !verifyUserExist;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    ...mapMutations(["setLoad", "setItemsBread", "setUserSearchCriteria"])
  },
  validations: {
    user: {
      personal_info: {
        first_name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45),
          ValName
        },
        gender: {
          required
        },
        date_of_birth: {
          validateBirth,
          required
        },
        document: {
          type: {
            required: false
          },
          value: {
            minLength: minLength(3),
            maxLength: maxLength(45)
          }
        },
        contact: {
          type: {
            required: false
          }
        },
        phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        }
      },
      profile: {
        image: {
          required: false
        }
      },
      address: {
        country: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(70)
        },
        city: {
          minLength: minLength(3)
        },
        state: {
          minLength: minLength(3)
        },
        postal_code: {
          minLength: minLength(4)
        },
        street: {
          minLength: minLength(3)
        }
      },
      agreement: {
        position: {
          required
        },
        start_date: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        end_date: {
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        notes: {
          maxLength: maxLength(200)
        }
      },
      account: {
        password: {
          minLength: minLength(8),
          strongPassword(password) {
            if (password === "") {
              return true;
            } else {
              return (
                /[a-z]/.test(password) && // checks for a-z
                /[A-Z]/.test(password) && // checks for A-Z
                /[0-9]/.test(password) && // checks for 0-9
                /\W|_/.test(password) && // checks for special char
                password.length >= 8
              );
            }
          }
        },
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (validateEmail(value)) {
              return this.lastEmail !== value
                ? await this.verifyUserEmail(value)
                : true;
            }
            return false;
          }
        }
      },
      relationship: {
        type: {
          required
        }
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs(function() {
        return this.user.account.password;
      })
    }
  },
  components: {
    flatPicker,
    VueTelInput,
    WSelect
  },
  computed: {
    ...mapGetters(["countries", "sesion", "load"])
  },
  beforeRouteLeave(to, from, next) {
    this.isInMemberModule(to.meta.modules);
    this.detectChanges(to, from, next);
  }
};
</script>
